export default "__VITE_ASSET__jgv99SPq__"